@if (loadingState$ | async; as loadingState) {
  @if (loadingState.isLoading) {
    <div class="alternative-container">
      <ipo-loading-spinner></ipo-loading-spinner>
    </div>
  }
  @if (loadingState.hasError) {
    <div class="alternative-container">
      <ipo-alert type="danger">
        {{ 'errorFetchingDucts' | translate }}
      </ipo-alert>
    </div>
  }
  @if (loadingState.hasLoaded) {
    @if ({ value: searchValue$ | async }; as searchValue) {
      @if (ductData$ | async; as allDucts) {
        <div class="ducts-siderbar-container">
          <div class="header-section">
            <gc-text [variant]="'minorHeading'">{{
              'ducts' | translate
            }}</gc-text>
            <gc-button
              [icon]="'x'"
              [variant]="'plain'"
              (clicked)="onDuctMenuClicked($event)"
            />
          </div>
          <div class="search-container">
            <gc-input-field
              [placeholder]="'searchDucts' | translate"
              [label]="'searchDuct' | translate"
              [value]="searchValue.value"
              (changed)="handleSearch($event)"
              class="search-container_input"
            />
            <gc-button
              class="showAll"
              [variant]="'secondary'"
              [disabled]="searchValue.value === ''"
              (click)="handleSearch('')"
              (keydown.enter)="handleSearch('')"
            >
              {{ 'clear' | translate }}
            </gc-button>
          </div>
          <ipo-flexible-table
            class="ducts-table margin-bottom-6"
            [dataSet]="
              allDucts
                | filterDuctMappings
                  : searchValue.value
                  : findSpanIdFromSerialNumber(searchValue.value)
                | limitShownMappings: activePage
            "
            [columns]="
              columns | translateArray: (language$ | async)! : 'header'
            "
            [expandableRows]="true"
            [clickableRows]="true"
            [markRowFn]="markSelectedRow((selectedDuct$ | async)!)"
            (rowClicked)="onRowClicked($event)"
          >
            <ng-template ipoTableColumn="ductId" let-duct>
              <div class="duct-id-col">
                {{ duct.ductSegmentName }}
              </div>
            </ng-template>
            <ng-template ipoTableColumn="type" let-duct>
              <div class="duct-status-col">
                {{ duct.name }}
              </div>
            </ng-template>
            <ng-template ipoTableColumn="color" let-duct>
              <div class="duct-status-col">
                {{ duct.colorName }}
              </div>
            </ng-template>
            <ng-template ipoTableExpandedRow let-duct>
              <div class="subduct_container">
                <div class="subduct_header">{{ 'subDucts' | translate }}</div>
                <div class="subduct">
                  @for (subDuct of duct.subDucts; track subDuct) {
                    <div class="subduct-item">
                      {{ subDuct?.name }}
                      <span
                        class="subduct-item_color"
                        [ngStyle]="{ 'border-color': subDuct.colorCode }"
                      >
                      </span>
                    </div>
                  }
                </div>
              </div>
            </ng-template>
          </ipo-flexible-table>
          <ipo-pagination
            class="pagination-wrapper"
            [activePage]="activePage"
            [numberOfPages]="
              allDucts | filterDuctMappings: searchValue.value | calcNumPages
            "
            (pageChange)="onPageChange($event)"
          ></ipo-pagination>
        </div>
      }
    }
  }
}
